__webpack_require__.p = "/E-commerce-semijoias/";